var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-super-kline"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"kline-loading"},[_c('div',{staticClass:"loading-spinner"})]),_c('div',{attrs:{"id":"tv_chart_container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }